import styled from 'styled-components'
import tabletGiantFooterBottomAsset from './tablet-giant-footer-bottom.svg'

import media from 'media'

const TabletGiantFooterBottomAsset = styled.img.attrs({
  src: tabletGiantFooterBottomAsset,
})`
  position: absolute;
  left: 0;
  bottom: 0;
  display: none;

  ${media.tablet`
    display: block;
  `}

  ${media.desktop`
    display: none;
  `}

  ${media.giant`
    display: block;
  `}
`

export default TabletGiantFooterBottomAsset
